module.exports = __webpack_public_path__ + "static/img/RP-F24V6_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-F24V6_1.png
// module id = UZnQ
// module chunks = 0